module.exports = __webpack_public_path__ + "static/media/FieldTest2.ee13dd70.png";